import { render, staticRenderFns } from "./ovisAdmin.html?vue&type=template&id=3bc0cf0e&scoped=true&external"
import script from "./ovisAdmin.vue?vue&type=script&lang=js"
export * from "./ovisAdmin.vue?vue&type=script&lang=js"
import style0 from "./ovisAdmin.scss?vue&type=style&index=0&id=3bc0cf0e&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc0cf0e",
  null
  
)

export default component.exports